function execNestedCommand(command, parentCommand, ...params) {
    const editorFocus = command.editorFocus;
    const canUndo = command.canUndo;

    try {
        command.editorFocus = parentCommand.editorFocus;
        command.canUndo = parentCommand.canUndo;

        command.exec(...params);
    } finally {
        command.editorFocus = editorFocus;
        command.canUndo = canUndo;
    }
}

export default {
    execNestedCommand
};
